import { Typography, Button } from "@mui/material";

const BaseButton = ({
	id,
	type = "button",
	disabled = false,
	className = "",
	titleClassName = "",
	titleColor = "white",
	size = "",
	width = "200px",
	title = "Button",
	onClick,
	variant = "contained",
	color = "primary",
	backgroundColor,
	borderWidth,
	borderColor,
}) => (
	<Button
		key={id}
		id={id}
		type={type}
		disabled={disabled}
		className={className}
		variant={variant}
		color={color}
		size={size || ""}
		style={{
			...(width && { width }),
			...(backgroundColor && { backgroundColor }),
			...(borderWidth && { borderWidth }),
			...(borderColor && { borderColor }),
		}}
		onClick={onClick}
	>
		<Typography className={titleClassName} sx={{ color: `${titleColor}!important` }} style={{ textTransform: "none" }}>
			<b>{title}</b>
		</Typography>
	</Button>
);

export const PrimaryBackgroundButton = (props) => (
	<BaseButton
		id={props.id || "primary-background-button"}
		variant="contained"
		color="primary"
		{...props}
	/>
);

export const PrimaryBorderButton = (props) => (
	<BaseButton
		id={props.id || "primary-border-button"}
		variant="outlined"
		color="primary"
		titleColor={props.titleColor || "primary"}
		backgroundColor={props.backgroundColor || "white"}
		borderWidth="3px"
		borderColor={props.titleColor || "primary"}
		{...props}
	/>
);

export const SecondaryBackgroundButton = (props) => (
	<BaseButton
		id={props.id || "secondary-background-button"}
		variant="contained"
		color="secondary"
		{...props}
	/>
);

export const SecondaryBorderButton = (props) => (
	<BaseButton
		id={props.id || "secondary-border-button"}
		variant="outlined"
		color="secondary"
		titleColor={props.titleColor || "secondary"}
		backgroundColor={props.backgroundColor || "white"}
		borderWidth="3px"
		{...props}
	/>
);

export const HighlightBackgroundButton = (props) => (
	<BaseButton
		id={props.id || "highlight-background-button"}
		variant="contained"
		color="third"
		{...props}
	/>
);

export const HighlightBorderButton = (props) => (
	<BaseButton
		id={props.id || "highlight-border-button"}
		variant="outlined"
		color="third"
		titleColor={props.titleColor || "third"}
		backgroundColor={props.backgroundColor || "white"}
		borderWidth="3px"
		{...props}
	/>
);

export const SuccessBackgroundButton = (props) => (
	<BaseButton
		id={props.id || "success-background-button"}
		variant="contained"
		color="success"
		{...props}
	/>
);

export const ErrorBackgroundButton = (props) => (
	<BaseButton
		id={props.id || "error-background-button"}
		variant="contained"
		color="error"
		{...props}
	/>
);

export const InfoBackgroundButton = (props) => (
	<BaseButton
		id={props.id || "info-background-button"}
		variant="contained"
		color="info"
		{...props}
	/>
);

export const BackButton = ({
	id = "back-button",
	title = "Πίσω",
	onClick,
	...props
}) => (
	<Button
		key={id}
		id={id}
		onClick={onClick}
		sx={{
			marginTop: "1rem",
			padding: "0.5rem 1rem",
			backgroundColor: "third",
			color: "secondary.main",
			border: "none",
			borderRadius: "4px",
			cursor: "pointer",
			...props.sx,
		}}
		{...props}
	>
		{title}
	</Button>
);
